(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('GpfsBatchInvoiceDeleteController',GpfsBatchInvoiceDeleteController);

    GpfsBatchInvoiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'GpfsBatchInvoice'];

    function GpfsBatchInvoiceDeleteController($uibModalInstance, entity, GpfsBatchInvoice) {
        var vm = this;

        vm.gpfsBatchInvoice = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GpfsBatchInvoice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
